import React, { useEffect, useState } from 'react';
import { Observer } from 'mobx-react';
import { Redirect, useLocation } from 'react-router-dom';
import { Button, Snackbar, Slide, IconButton } from '@material-ui/core';
import { css } from '@emotion/core';
import CloseIcon from '@material-ui/icons/Close';
import axios from 'axios';

import { useRootStore } from '../../stores/BridgeProvider';
import storageService from '../../services/storage.service';
import { FlexDiv, LoginBox } from '../styles/styles';
import Logo from '../../assets/DEAL MAP-LOGO.png';
import { COLORS } from '../util/Colors';

const imageBox = css`
  display: flex;
  justify-content: center;
`;

const Login = () => {
  const { authStore } = useRootStore();
  const { search, state } = useLocation();
  const inactivityDisplay = search.includes('inactivity');
  const [showInactivityBar, setShowInactivityBar] = useState(false);
  const login = () => authStore.login();
  const signup = () => authStore.signup();

  const sendVerificationEmail = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API}/api/verify-email`, {
        email: state.email,
        sub: state.sub,
        name: state.name,
      });
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    const updateReferral = async () => {};
    if (window.location.search.length > 0) updateReferral();
    document.body.style.background = COLORS.midnight;
    return () => {
      document.body.style.background = COLORS.background;
    };
  }, []);

  useEffect(() => {
    if (inactivityDisplay) setShowInactivityBar(true);
  }, [inactivityDisplay]);

  useEffect(() => {
    const q = window.location.search.slice(1);
    if (q.length > 0) {
      const qSplit = q.split('&');
      qSplit.forEach(a => {
        const aSplit = a.split('=');
        storageService.setItem(aSplit[0], aSplit[1]);
      });
    }
  });

  useEffect(() => {
    if (state && state.error) {
      sendVerificationEmail();
    }
  }, []);

  return (
    <Observer
      render={() => {
        const { isAuthenticated } = authStore;
        if (isAuthenticated) return <Redirect to="/select-organization" />;
        return (
          <FlexDiv>
            <LoginBox>
              <div css={imageBox}>
                <img src={Logo} alt="logo" height="100px" width="120px" />
              </div>
              <h2>
                Welcome to Deal Map
                <sup style={{ fontSize: '0.8rem', fontWeight: '500' }}>
                  Beta
                </sup>
              </h2>

              <div
                style={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  flexFlow: 'column nowrap',
                  alignItems: 'center',
                  justifyContent: 'space-evenly',
                }}
              >
                {state && (
                  <p
                    style={{
                      fontSize: '0.8rem',
                      width: '250px',
                    }}
                  >
                    ** {state.error} **
                    <br />{' '}
                    <span
                      onClick={() => sendVerificationEmail()}
                      style={{
                        color: COLORS.blue,
                        cursor: 'pointer',
                        fontWeight: '600',
                      }}
                    >
                      Click here
                    </span>{' '}
                    to resend email
                  </p>
                )}
                <Button
                  style={{ width: 'inherit' }}
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={login}
                >
                  Log In
                </Button>
                <p
                  style={{
                    fontSize: '0.8rem',
                    width: '250px',
                  }}
                >
                  <span
                    onClick={signup}
                    style={{
                      color: COLORS.blue,
                      cursor: 'pointer',
                      fontWeight: '600',
                    }}
                  >
                    Click here
                  </span>{' '}
                  to sign up if you've received your beta invite
                </p>
              </div>
            </LoginBox>
            <Snackbar
              open={showInactivityBar}
              TransitionComponent={Slide}
              message="You have been logged out due to inactivity."
              action={
                <IconButton
                  key="close"
                  aria-label="Close"
                  color="inherit"
                  onClick={() => setShowInactivityBar(false)}
                >
                  <CloseIcon />
                </IconButton>
              }
            />
          </FlexDiv>
        );
      }}
    />
  );
};

export default Login;
